// This function checks if the user is an admin based on their email

import { getConfig } from '.';

const allowedList = getConfig('siteAdminEmails');
const queryString = window.location.search;
const urlParams = new URLSearchParams(queryString);

const isAdminUser = (userEmail?: string) => {
    let isAdmin = false;
    if (allowedList && allowedList.length > 0 && userEmail && urlParams.has('kingcharles')) {
        isAdmin = allowedList.some((email: string) => userEmail.toLowerCase().includes(email));
    }
    return isAdmin;
};

export default isAdminUser;
